import { STATUS_CODE_BY_INFO_EVENT_CODE } from 'constants/video/videoselfie';

export const getStatusCodeFromInfoEventCode = eventCode => {
    const statusCode = STATUS_CODE_BY_INFO_EVENT_CODE[eventCode];
    if (statusCode) return statusCode;

    return null;
};
